module.exports = __webpack_public_path__ + "static/media/rede-protecao-5.ce2b139f.jpeg";